import React from "react";
import "./EventDetailsCard.css";

const EventDetailsCard = ({ Details }) => {
  const convertToCST = (dateString, options = {}) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", { timeZone: "America/Chicago", ...options });
  };

  const priceForAllBets =
    Details.price_per_bet && Details.price_per_bet * Details.no_of_questions;

  return (
    <>
      {Details.deleted && (
        <div className="alert alert-danger d-flex align-items-center mb-3" role="alert">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
          </svg>
          <div>
            <strong>This event has been deleted.</strong> The data shown below is for reference only.
          </div>
        </div>
      )}
      <div className={`card mt-sm-4 mb-sm-4 ${Details.deleted ? 'border-danger' : ''}`}>
        <div className="row m-0">
          <div className="col-lg-3 p-0 d-flex justify-center align-items-center">
            <div className="card-body text-center mt-4 mb-4">
              <img
                src={Details.image_url}
                alt="avatar"
                className=" img-fluid"
                style={{
                  width: "250px",
                  height: "250px",
                  borderRadius: "10px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>

          <div className="col-lg-9 mt-4 mb-4">
            <div className="row">
              <div className="col-lg-12">
                <div className="mb-4">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 event-detail">
                        <div>
                          <label>Event Title</label>
                          <p className="text-muted mb-0">
                            {Details.event_title}
                          </p>
                        </div>
                        <div>
                          <label>Is Prepaid</label>
                          <p className="text-muted mb-0">
                            {Details.is_prepaid ? "Yes" : "No"}
                          </p>
                        </div>
                        {Details.app_type === 1 && (
                          <div>
                            <label>Social Incentive</label>
                            <p className="text-muted mb-0">
                              {Details.social_incentive_enabled === false ? "Disabled" : "Enabled"}
                            </p>
                          </div>
                        )}
                        <div>
                          <label>Description</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.event_description}
                          </p>
                        </div>
                        <div>
                          <label>Address</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.event_location}
                          </p>
                        </div>
                        <div>
                          <label>Bride Name</label>
                          <p className="text-muted mb-0">
                            {Details.bride_name ? Details.bride_name : "NA"}
                          </p>
                        </div>
                        <div>
                          <label>Groom Name</label>
                          <p className="text-muted mb-0">
                            {Details.groom_name ? Details.groom_name : "NA"}
                          </p>
                        </div>
                        <div>
                          <label>Event Organizer Name</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.event_creators_full_name
                              ? Details.event_creators_full_name
                              : "NA"}
                          </p>
                        </div>
                        <div>
                          <label>Event Organizer Email</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.event_creators_email
                              ? Details.event_creators_email
                              : "NA"}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4 event-detail">
                        <div>
                          <label>Groom/Bride Email</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.groom_or_bride_email
                              ? Details.groom_or_bride_email
                              : "NA"}
                          </p>
                        </div>
                        <div>
                          <label>Event Date</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {convertToCST(`${Details.event_date} 00:00:00`, { year: 'numeric', month: '2-digit', day: '2-digit' })}
                          </p>
                        </div>
                        <div className="w-75">
                          <label>Invite link</label>
                          <p className="text-muted mb-0">
                            <a
                              href={Details.invite_link}
                              className="text-muted mb-0"
                            >
                              {" "}
                              {Details.invite_link}
                            </a>
                          </p>
                        </div>
                        <div>
                          <label>Prepaid At</label>
                          <p className="text-muted mb-0">
                            {Details.prepaid_at ? Details.prepaid_at : "NA"}
                          </p>
                        </div>
                        <div>
                          <label>Created date</label>
                          <p className="text-muted mb-0">
                            {new Date(Details.created_at).toLocaleString()}
                          </p>
                        </div>
                        <div>
                          <label>Event status</label>
                          <p className="text-muted mb-0">
                            {Details.status}
                            {Details.deleted && (
                              <span className="badge bg-danger ms-2">Deleted</span>
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4 event-detail">
                        <div>
                          <label>Is Bride/Groom</label>
                          <p className="text-muted mb-0">
                            {Details.is_groom_or_bride === null
                              ? "NA"
                              : Details.is_groom_or_bride
                              ? "Yes"
                              : "No"}
                          </p>
                        </div>
                        <div>
                          <label>Number Of Questions</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.no_of_questions}
                          </p>
                        </div>
                        <div>
                          <label>Amount for per Bets</label>
                          <p className="text-muted mb-0">
                            {Details.price_per_bet
                              ? `${Details.price_per_bet} ${Details.currency_type}`
                              : "NA"}
                            {/* {Details.price_per_bet} {Details.currency_type} */}
                          </p>
                        </div>
                        <div>
                          <label>Amount for all Bets</label>
                          <p className="text-muted mb-0">
                            {Details.price_per_bet
                              ? `${priceForAllBets} ${Details.currency_type}`
                              : "NA"}
                            {/* {Details.price_per_bet} {Details.currency_type} */}
                          </p>
                        </div>
                        <div>
                          <label>Number of Participants</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.no_of_participants}
                          </p>
                        </div>
                        <div>
                          <label>Number of Estimated Guests</label>
                          <p className="text-muted mb-0">
                            {" "}
                            {Details.estimated_no_of_guests ? Details.estimated_no_of_guests : "NA"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EventDetailsCard;
